import { render, staticRenderFns } from "./lightbox.vue?vue&type=template&id=fe8f1c0a&scoped=true&"
import script from "./lightbox.vue?vue&type=script&lang=js&"
export * from "./lightbox.vue?vue&type=script&lang=js&"
import style0 from "./lightbox.vue?vue&type=style&index=0&id=fe8f1c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8f1c0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe8f1c0a')) {
      api.createRecord('fe8f1c0a', component.options)
    } else {
      api.reload('fe8f1c0a', component.options)
    }
    module.hot.accept("./lightbox.vue?vue&type=template&id=fe8f1c0a&scoped=true&", function () {
      api.rerender('fe8f1c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/lightbox.vue"
export default component.exports